import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { LoadingPlugin } from 'vue-loading-overlay';
// import PrimeVue from 'primevue/config';
import 'vue-loading-overlay/dist/css/index.css';

import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';

import VueGoogleMaps from '@fawmi/vue-google-maps'

import VOtpInput from "vue3-otp-input";

const app = createApp(App);
app.use(store);
app.use(router);
app.use(PrimeVue, {
    theme: {
        preset: Aura
    }
});

app.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyCrSdO6eCgjTZQRL2Rc1A3PfHE7VwvhUD8', // Replace with your actual Google Maps API key
    }
})

app.component('v-otp-input', VOtpInput);

app.use(LoadingPlugin);
// app.directive('can',{
//     mounted: function(el, binding){
//         let permissions = store.getters.permissions;
//         let user = store.getters.user;
//         if(permissions && permissions.length != 0){
//             let permission = permissions.filter(element => {
//                 if(user){
//                     if(user.user_type=='PMT') {
//                         return (element.ability.ability == binding.value) && (element.ability.user_type=='PMT' || element.ability.user_type=='BOTH');
//                     }
//                     else if(user.user_type=='BATS') {
//                         return (element.ability.ability == binding.value) && (element.ability.user_type=='BATS' || element.ability.user_type=='BOTH');
//                     }
//                     else {
//                         return element.ability.ability == binding.value;
//                     }
//                 }
//             })
//             if(!permission[0]){
//                 el.parentNode.removeChild(el);
//             }
//         }
//         else{
//             el.parentNode.removeChild(el);
//         }
//     }
// });

app.mount('#app');
